// @flow

import React from 'react';
import { InputV2, InputConsumer } from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';
import FileTableField from '../Field/FileTableField';

const FileTableReferenceView = ({
  schema: getSchema,
  setValue,
  value
}: types.FileTableReferenceView) => {
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    context,
    className,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });

  return (
    <InputV2
      className={className}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <FileTableField
            contentMediaType={schema?.contentMediaType}
            context={context}
            data-testid="fileTableReferenceView"
            embedded={embedded}
            id={id}
            name={name}
            required={required}
            schema={schema}
            value={value}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
FileTableReferenceView.displayName = 'FileTableReferenceView';

export default React.memo<types.FileTableReferenceView>(FileTableReferenceView);
